import React from 'react';
import { Footer } from '../../organims/footer';
import { Button, Col, Container, Row, Badge } from 'react-bootstrap';
import { Fade } from 'react-awesome-reveal';
import { useParams } from 'react-router-dom';
import { projectsData } from '../../../Assets/data/projects';

export const PortfolioDetail = () => {
  const { projectId } = useParams();
  const project = projectsData.find((val) => val.id === projectId);

  if (!project) {
    return (
      <Container className="text-center py-5">
        <h2>Proyecto no encontrado</h2>
      </Container>
    );
  }

  // Extraemos la info para facilitar su uso en el render
  const info = project.explain[0];

  return (
    <>
      <Container id='home' className="py-5">
        <Fade>

          {/* Título y Descripción Corta */}
          <Row className="mb-5 border-bottom pb-4">
            <Col>
              <h2 className='text-dark display-5 fw-bold mb-3'>{project.name}</h2>
              <p className="lead text-muted">{project.about}</p>
            </Col>
          </Row>

          <Row>
            {/* Columna Izquierda: Detalles del caso de estudio */}
            <Col xs={12} md={9} className="pe-md-5">

              <h3 className="mb-3">Overview</h3>
              <p className="mb-4">{info.background}</p>

              {info.challenge && (
                <>
                  <h3 className="mb-3 mt-4">Challenge</h3>
                  <p className="mb-4">{info.challenge}</p>
                </>
              )}

              {info.features && (
                <>
                  <h3 className="mb-4 mt-5">Main Features</h3>
                  <Row>
                    {info.features.map((feature, idx) => (
                      <Col xs={12} md={6} key={idx} className="mb-4">
                        <div className="p-4 bg-light rounded h-100 border shadow-md">
                          <h5 className="fw-bold">{feature.title}</h5>
                          <p className="text-muted mb-0">{feature.description}</p>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </>
              )}

              {info.result && (
                <>
                  <h3 className="mb-3 mt-5">The Result</h3>
                  <div className="p-4 bg-dark rounded">
                    <p className="mb-0 text-white">{info.result}</p>
                  </div>
                </>
              )}
            </Col>

            {/* Columna Derecha: Sidebar con Rol, Stack y Botón */}
            <Col xs={12} md={3} className="mt-5 mt-md-0">
              <div className="sticky-top" style={{ top: '100px' }}>
                <span className='d-block fw-bold mb-2 text-uppercase text-secondary' style={{fontSize: '0.85rem'}}>
                  My role
                </span>
                {project.role.map((item, index) => (
                  <Badge key={index} bg="dark" className='me-2 mb-2 px-3 py-2'>
                    {item}
                  </Badge>
                ))}

                <span className='d-block fw-bold mt-4 mb-2 text-uppercase text-secondary' style={{fontSize: '0.85rem'}}>
                  Stack
                </span>
                {project.tech.map((item, index) => (
                  <Badge key={index} bg="secondary" className='me-2 mb-2 px-3 py-2'>
                    {item}
                  </Badge>
                ))}

                <hr className="my-4" />

                <a
                  aria-label={`Open ${project.name} website`}
                  href={project.link}
                  target='_blank'
                  rel="noopener noreferrer"
                >
                  <Button
                    className='d-block w-100 py-2 fw-bold'
                    variant='primary'
                  >
                    View site
                  </Button>
                </a>
              </div>
            </Col>
          </Row>
        </Fade>
      </Container>
      <Footer />
    </>
  );
};